export default __webpack_public_path__ + "static/media/GroupBrainLock.32f9afb1.svg";